import { useId, useState, type ReactNode } from "react";
import { Buton } from "@koclukpanel/ui";
import { api } from "./api";
import { Karne as OrtakKarne, useKarneAcik } from "../../ogrenci/src/Karne";

export function Karne({ ogrenciId }: { ogrenciId: string }) {
  return <OrtakKarne ogrenciId={ogrenciId} istek={api} />;
}

/** F-EXM-25 — öğrenci dosyasının karne girişi bayrak açıkken eklenir. */
export function KarneDosyaSekmesi({
  ogrenciId,
  children,
}: {
  ogrenciId: string;
  children: ReactNode;
}) {
  const acik = useKarneAcik(api);
  const [secili, setSecili] = useState("dosya");
  const kimlik = useId();
  const sekmeler = [
    { deger: "dosya", etiket: "Öğrenci dosyası" },
    { deger: "karne", etiket: "Karne" },
  ];
  return (
    <div className="min-w-0 space-y-4">
      {acik ? (
        <>
          <div
            role="tablist"
            aria-label="Öğrenci dosyası bölümleri"
            className="flex flex-wrap gap-2"
          >
            {sekmeler.map((sekme, sira) => (
              <Buton
                key={sekme.deger}
                id={`${kimlik}-${sekme.deger}`}
                role="tab"
                aria-selected={secili === sekme.deger}
                aria-controls={`${kimlik}-${sekme.deger}-icerik`}
                tabIndex={secili === sekme.deger ? 0 : -1}
                onClick={() => setSecili(sekme.deger)}
                onKeyDown={(olay) => {
                  const hedef =
                    olay.key === "Home"
                      ? 0
                      : olay.key === "End"
                        ? 1
                        : olay.key === "ArrowLeft" || olay.key === "ArrowRight"
                          ? 1 - sira
                          : null;
                  if (hedef === null) return;
                  olay.preventDefault();
                  setSecili(hedef === 0 ? "dosya" : "karne");
                  olay.currentTarget.parentElement
                    ?.querySelectorAll<HTMLButtonElement>("[role=tab]")
                    [hedef]?.focus();
                }}
              >
                {sekme.etiket}
              </Buton>
            ))}
          </div>
          {/* F-EXM-25 — her sekme sabit bir paneli işaret eder; gizli karne veri istemez. */}
          {sekmeler.map((sekme) => (
            <div
              key={sekme.deger}
              id={`${kimlik}-${sekme.deger}-icerik`}
              role="tabpanel"
              aria-labelledby={`${kimlik}-${sekme.deger}`}
              hidden={secili !== sekme.deger}
              tabIndex={0}
            >
              {secili === sekme.deger &&
                (sekme.deger === "karne" ? <Karne ogrenciId={ogrenciId} /> : children)}
            </div>
          ))}
        </>
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
}
